import React, { Fragment, ReactElement } from 'react';

import { IParentProps } from '../types/IParentProps';

export type IIfProps = IParentProps & {
    condition: boolean;
};

export function If (props: IIfProps): ReactElement | null {
    const { condition, children }: IIfProps = props;

    if (condition) {
        return <Fragment>{children}</Fragment>;
    }

    return null;
}

